import { PreguntaCargaDTO } from "@DTOS";
import { PreguntasTipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaMatrixRangeImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.MATRIX_RANGE;
    }

    public procesar(datos: DatosPreguntaImportador[]): PreguntaCargaDTO[] {
        const preguntas = super.procesar(datos);
        const preguntaPadre = preguntas[PREGUNTA_PADRE];
        preguntaPadre.items.forEach(item => {
            item.texto = "__RANGE_VALUE__";
        });
        preguntas.slice(1).forEach(pregunta => {
            pregunta.minimo = preguntaPadre.minimo;
            pregunta.maximo = preguntaPadre.maximo;
            pregunta.paso = preguntaPadre.paso;
        });
        return preguntas;
    }

    public testear(datos: DatosPreguntaImportador[], esUltima: boolean = false): boolean {
        let pasoTest = super.testear(datos, esUltima);
        const preguntaPadre = datos[PREGUNTA_PADRE];
        if (preguntaPadre.min == null || preguntaPadre.max == null || preguntaPadre.step == null) {
            this.errores.push(
                `La pregunta ${preguntaPadre.idPregunta} tiene mal el formato de ##Min/Max falta el minimo, maximo o el step`
            );
            pasoTest = false;
        }
        if (!preguntaPadre.random && preguntaPadre.tipoOpcion !== "R") {
            this.advertencias.push(
                `La pregunta ${datos[PREGUNTA_PADRE].idPregunta} no esta marcada como Random`
            );
        }
        return pasoTest;
    }
}
